package io.horion.cv.utils

import io.horion.cv.models.User

// Données de test pour User
object UserTestData {

    // Utilisateurs individuels (candidats)
    val individualUsers = listOf(
        User(
            id = "user_001",
            nom = "Jean Dupont",
            email = "jean.dupont@email.com",
            phone = "+237 612345678"
        ),
        User(
            id = "user_002",
            nom = "Sophie Bernard",
            email = "sophie.bernard@email.com",
            phone = "+237 623456789"
        ),
        User(
            id = "user_003",
            nom = "Marie Martin",
            email = "marie.martin@email.com",
            phone = "+237 634567890"
        ),
        User(
            id = "user_004",
            nom = "Thomas Petit",
            email = "thomas.petit@email.com",
            phone = "+237 645678901"
        ),
        User(
            id = "user_005",
            nom = "Julie Moreau",
            email = "julie.moreau@email.com",
            phone = "+237 656789012"
        ),
        User(
            id = "user_006",
            nom = "Lucas Dubois",
            email = "lucas.dubois@email.com",
            phone = "+237 667890123"
        ),
        User(
            id = "user_007",
            nom = "Emma Blanc",
            email = "emma.blanc@email.com",
            phone = "+237 678901234"
        ),
        User(
            id = "user_008",
            nom = "Nicolas Leroy",
            email = "nicolas.leroy@email.com",
            phone = "+237 689012345"
        ),
        User(
            id = "user_009",
            nom = "Camille Rousseau",
            email = "camille.rousseau@email.com",
            phone = "+237 690123456"
        ),
        User(
            id = "user_010",
            nom = "Antoine Girard",
            email = "antoine.girard@email.com",
            phone = "+237 601234567"
        )
    )

    // Utilisateurs entreprises (recruteurs)
    val companyUsers = listOf(
        User(
            id = "company_001",
            nom = "TechCorp Solutions",
            email = "recrutement@techcorp.com",
            phone = "+237 611223344"
        ),
        User(
            id = "company_002",
            nom = "DataCo Africa",
            email = "jobs@dataco.africa",
            phone = "+237 622334455"
        ),
        User(
            id = "company_003",
            nom = "ManageIT Group",
            email = "hr@manageit.com",
            phone = "+237 633445566"
        ),
        User(
            id = "company_004",
            nom = "DesignHub Creative",
            email = "careers@designhub.com",
            phone = "+237 644556677"
        ),
        User(
            id = "company_005",
            nom = "CloudSys Technologies",
            email = "jobs@cloudsys.tech",
            phone = "+237 655667788"
        ),
        User(
            id = "company_006",
            nom = "InnovateLab",
            email = "contact@innovatelab.com",
            phone = "+237 666778899"
        )
    )

    // Tous les utilisateurs
    val allUsers = individualUsers + companyUsers

    // Fonctions utilitaires pour filtrer
    fun getUserById(id: String): User? {
        return allUsers.find { it.id == id }
    }

    fun getUsersByNom(nom: String): List<User> {
        return allUsers.filter { it.nom.contains(nom, ignoreCase = true) }
    }

    fun getIndividualUsers(): List<User> = individualUsers

    fun getCompanyUsers(): List<User> = companyUsers

    // Fonction pour créer un nouvel utilisateur avec ID auto-généré
    fun createUser(nom: String, email: String, phone: String): User {
        val newId = "user_${(allUsers.size + 1).toString().padStart(3, '0')}"
        return User(
            id = newId,
            nom = nom,
            email = email,
            phone = phone
        )
    }
}